import { startOfDay } from "date-fns";

export const todaysDateTimeSetToStartOfDay = () => startOfDay(new Date());
